import { createNode, DurationDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { toDuration } from '../../utils/temporal';

export const TotalDuration = createNode({
    id: 'Total Duration',
    name: 'Total Duration',
    description: 'Converts a Duration to a total number in the specified unit',
    aiDescription:
        'Takes a Duration on the "Duration" port and a unit selection on the "Unit" port (hours, minutes, seconds, milliseconds, or days), and outputs the total as a number on the "Total" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Duration: DurationDataType,
        Unit: {
            kind: 'union',
            subTypes: [
                { kind: 'stringLiteral', stringLiteral: 'hours' },
                { kind: 'stringLiteral', stringLiteral: 'minutes' },
                { kind: 'stringLiteral', stringLiteral: 'seconds' },
                { kind: 'stringLiteral', stringLiteral: 'milliseconds' },
                { kind: 'stringLiteral', stringLiteral: 'days' },
            ],
        },
    },
    outPorts: {
        Total: { kind: 'number' },
    },
    execute: function (input) {
        const duration = toDuration(input.inPorts.Duration);
        const unit = input.inPorts.Unit as string;
        const total = duration.total({ unit: unit as Temporal.TotalUnit<Temporal.DateTimeUnit>, relativeTo: Temporal.Now.plainDateISO() });
        return { output: { Total: total } };
    },
});
